import {
  Table,
  TableHeader,
  TableBody,
  TableRow,
  TableHead,
  TableCell,
} from '@mustauto/ui/web';
import { Badge } from '@/components/ui/badge';
import { Card, CardHeader, CardTitle, CardContent } from '@mustauto/ui/web';
import { InviteLinkButton } from '@/components/InviteLinkButton';
import { STATUS_MAP } from '@/lib/status';
import type { DashboardOrder } from '@/hooks/useDashboard';
import { useRouter } from '@tanstack/react-router';
import { MessageSquare, ClipboardList } from 'lucide-react';
import { EmptyState } from '@mustauto/ui/web';

export function RecentOrdersTable({ orders }: { orders: DashboardOrder[] }) {
  const router = useRouter();
  if (orders.length === 0) {
    return (
      <Card>
        <CardHeader>
          <CardTitle className="text-base font-semibold text-foreground">
            OS do Dia
          </CardTitle>
        </CardHeader>
        <CardContent>
          <EmptyState
            icon={<ClipboardList size={28} />}
            title="Nenhuma OS hoje"
            description="Ainda não foram abertas ordens de serviço hoje. Crie uma nova OS para começar."
            action={{ label: 'Nova OS', href: '/service-orders/new' }}
          />
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-base font-semibold text-foreground">
          OS do Dia
        </CardTitle>
      </CardHeader>
      <CardContent className="p-0">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>#</TableHead>
              <TableHead>Placa</TableHead>
              <TableHead>Veículo</TableHead>
              <TableHead>Mecânico</TableHead>
              <TableHead>Status</TableHead>
              <TableHead>Previsão</TableHead>
              <TableHead>Ações</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {orders.map((order) => {
              const cfg = STATUS_MAP[order.status];
              return (
                <TableRow key={order.id}>
                  <TableCell className="font-medium">{order.number}</TableCell>
                  <TableCell className="font-mono font-semibold">
                    {order.plate}
                  </TableCell>
                  <TableCell>{order.vehicleName}</TableCell>
                  <TableCell>{order.mechanicName}</TableCell>
                  <TableCell>
                    {cfg ? (
                      <Badge variant={cfg.variant}>{cfg.label}</Badge>
                    ) : (
                      <Badge variant="outline">{order.status}</Badge>
                    )}
                  </TableCell>
                  <TableCell>
                    {order.deadline
                      ? new Date(order.deadline).toLocaleDateString('pt-BR')
                      : '—'}
                  </TableCell>
                  <TableCell>
                    <div className="flex items-center gap-2">
                      <button
                        className="rounded-md p-1.5 text-muted-foreground hover:bg-muted hover:text-foreground"
                        title="Chat da OS"
                        onClick={() =>
                          router.navigate({
                            to: '/service-orders/$osId',
                            params: { osId: order.id },
                          })
                        }
                      >
                        <MessageSquare size={16} />
                      </button>
                      <InviteLinkButton vehicleId={order.vehicleId} />
                    </div>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}
